import api from "./configuration";
import apiUrl from "./url";

const USE_AUTH_INTERCEPTOR = true;

export const RosterAPI = {
	activityMatrix: async (id, params) =>
		(
			await api.request({
				method: "GET",
				url: apiUrl + "/Rosters/" + id + "/activity-matrix",
				useAuthInterceptor: USE_AUTH_INTERCEPTOR,
				params,
			})
		).data,
	list: async (params) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Rosters",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			params,
		});

		return response.data;
	},
	listAllForAssignment: async () => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Rosters/AllForAssignment",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	create: async (data) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/Rosters",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	getById: async (id) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Rosters/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	delete: async (id) => {
		const response = await api.request({
			method: "DELETE",
			url: apiUrl + "/Rosters/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	update: async (id, data) => {
		const response = await api.request({
			method: "PUT",
			url: apiUrl + "/Rosters/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	getPlayers: async (id) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Rosters/" + id + "/players",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	addPlayers: async (data) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/Rosters/players",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	deletePlayer: async (id, playerId, returnToPool = true) => {
		const response = await api.request({
			method: "DELETE",
			url: apiUrl + "/Rosters/" + id + "/players/" + playerId,
			params: {returnToPool},
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	transferPlayer: async (rosterId, playerId, data) => {
		const response = await api.request({
			method: "POST",
			url:
				apiUrl + "/Rosters/" + rosterId + "/players/" + playerId + "/transfer",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	getStaffs: async (id) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Rosters/" + id + "/staff",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	addStaffs: async (data) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/Rosters/staff",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	deleteStaff: async (id, staffId) => {
		const response = await api.request({
			method: "DELETE",
			url: apiUrl + "/Rosters/" + id + "/staff/" + staffId,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	getModules: async (id) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Rosters/" + id + "/modules",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	addModule: async (data) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/Rosters/modules",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	deleteModule: async (id, moduleId) => {
		const response = await api.request({
			method: "DELETE",
			url: apiUrl + "/Rosters/" + id + "/modules/" + moduleId,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	setDefaultModule: async (id, moduleId) => {
		const response = await api.request({
			method: "PUT",
			url: apiUrl + "/Rosters/" + id + "/modules/" + moduleId + "/default",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
};
